import { inject, Injectable } from '@angular/core';
import { map, Observable, take } from 'rxjs';
import { HttpMainService } from "../http-main.service";
import { CountryResponseModel, ListModel} from "@itb-monorepo/models";
import { LanguageService } from '../utility-services/language.service';



@Injectable()
export class CountriesService {
  baseUrl = '/member/';
  private _HttpMainService = inject(HttpMainService);
  private languageService = inject(LanguageService);

  getCountries(searchField?: string): Observable<ListModel<CountryResponseModel>> {
    const options = searchField ? { skip: 0, take: 1000, sort: `asc(priority),asc(name->>'${this.languageService.currentLang}')`, search: searchField } :
      { skip: 0, take: 1000, sort: `asc(priority),asc(name->>'${this.languageService.currentLang}')` };
    return this._HttpMainService.get(this.baseUrl + "v1/countries", { ...options }).pipe(map((response: ListModel<CountryResponseModel>) => ({
      ...response,
    })))
  }
}
